import * as api from './api';

export default class WidgetAnalyticsLogic {
    static getReport(filters, perPage) {
        return api.getReport(filters, perPage);
    }

    static getAccounts() {
        return api.getAccounts();
    }

    static getWidgets(accountId) {
        return api.getWidgets(accountId);
    }

    static getFilterOptions(accountId) {
        return api.getFilterOptions(accountId);
    }
}
